import { Cell, Row, Skeleton } from '@vizit/atoms';
import { cx } from '@vizit/theme';
import * as React from 'react';
import { rowClasses } from './organization-row.classes';

const OrganizationRowLoading = React.memo(() => {
  return (
    <Row className={cx(rowClasses({ disabled: true }))} aria-label="Loading organization row">
      {/* Name Cell */}
      <Cell className="py-8 px-12 w-1/6">
        <div className="flex items-center">
          <Skeleton className="h-12 w-32" variant="square" />
        </div>
      </Cell>

      {/* Account Type Cell */}
      <Cell className="py-8 px-12 w-1/6">
        <div className="flex items-center">
          <Skeleton className="h-10 w-20" variant="square" />
        </div>
      </Cell>

      {/* ICP Product Categories Cell */}
      <Cell className="py-8 px-12 w-1/4">
        <div className="flex items-center gap-1">
          <Skeleton className="h-6 w-16" variant="rounded" />
          <Skeleton className="h-6 w-20" variant="rounded" />
        </div>
      </Cell>

      {/* Created By Cell */}
      <Cell className="py-8 px-12 w-1/6">
        <div className="flex items-center">
          <Skeleton className="h-10 w-24" variant="square" />
        </div>
      </Cell>

      {/* Created At Cell */}
      <Cell className="py-8 px-12 w-1/6">
        <div className="flex items-center">
          <Skeleton className="h-10 w-20" variant="square" />
        </div>
      </Cell>

      {/* Actions Cell */}
      <Cell className="py-8 px-12 w-1/6">
        <div className="flex items-center gap-2">
          <Skeleton className="h-8 w-12" variant="rounded" />
          <Skeleton className="h-8 w-12" variant="rounded" />
        </div>
      </Cell>
    </Row>
  );
});

export { OrganizationRowLoading };
